import axios from 'axios'
import swal from 'sweetalert'
import qs from 'qs'

import { getProjects } from './manageProjects'
import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'
// import { parseTitleFromHtml } from '../../../functions/reactQuillHandling'

let defaultState = {
  // phase: 1,
  // project: {
  //   phaseOne: {
      title: "",
      shortId: '',
      client: "",
      // proposals: [],
      number: "",
      description: "",
      status: "Active",
      regulatoryRelated: "No",
      budgetedHours: 0.00,
      startDate: new Date(),
      targetEndDate: "",
    // },
    // phaseTwo: {
      projectLeads: [],
      analysts: [],
    // },
    // phaseThree: {
      directory: "",
      rduid: "",
      metadataValues: [],
    // },
    // phaseFour: {
    //   deliverables: [],
    //   update: "",
    // }
  // }
}

export default function manageProjectCreation(state = defaultState, action){
  switch(action.type){

    case "CHANGE_PHASE":
      return {...state, phase: action.payload}

    case "RESET_PHASE":
      return defaultState

/////////////////////////// BEGINING OF PHASE ONE
    case "CHANGE_START_DATE":
      return { ...state, startDate: action.payload }
      // return {
      //   ...state,
      //   project:{
      //     ...state.project,
      //     phaseOne:{
      //       ...state.project.phaseOne,
      //       startDate: action.payload
      //     }
      //   }
      // }
    case "CHANGE_TARGET_END_DATE":
      return { ...state, targetEndDate: action.payload }
      // return {
      //   ...state,
      //   project:{
      //     ...state.project,
      //     phaseOne:{
      //       ...state.project.phaseOne,
      //       targetEndDate: action.payload
      //     }
      //   }
      // }
    case "CHANGE_STATUS":
      return { ...state, status: action.payload }
    case "CHANGE_REGULATORY_RELATED":
      return { ...state, regulatoryRelated: action.payload }
    case "CHANGE_BUDGETED_HOURS":
      return { ...state, budgetedHours: action.payload }
      // return {
      //   ...state,
      //   project:{
      //     ...state.project,
      //     phaseOne:{
      //       ...state.project.phaseOne,
      //       status: action.payload
      //     }
      //   }
      // }
    case "CHANGE_DESCRIPTION":
      return { ...state, description: action.payload }
      // return {
      //   ...state,
      //   project:{
      //     ...state.project,
      //     phaseOne:{
      //       ...state.project.phaseOne,
      //       description: action.payload
      //     }
      //   }
      // }
    case "CHANGE_CLIENT":
      return { ...state, client: action.payload }
      // return {
      //   ...state,
      //   project:{
      //     ...state.project,
      //     phaseOne:{
      //       ...state.project.phaseOne,
      //       client: action.payload
      //     }
      //   }
      // }
    case "CHANGE_PROPOSALS":
      return { ...state, proposals: action.payload }
      // return {
      //   ...state,
      //   project:{
      //     ...state.project,
      //     phaseOne: {
      //       ...state.project.phaseOne,
      //       proposals: action.payload
      //     }
      //   }
      // }
    case "CHANGE_TITLE":
      if (action.payload.length <= 255) {
        return { ...state, title: action.payload }
        // return {
        //   ...state,
        //   project:{
        //     ...state.project,
        //     phaseOne:{
        //       ...state.project.phaseOne,
        //       title: action.payload
        //     }
        //   }
        // }
      } else {
        return state
      }
    case "CHANGE_SHORT_ID":
      return { ...state, shortId: action.payload.toUpperCase() }
      // if (action.payload.length <= 3) {
      //   return {
      //     ...state,
      //     project:{
      //       ...state.project,
      //       phaseOne:{
      //         ...state.project.phaseOne,
      //         shortId: action.payload.toUpperCase()
      //       }
      //     }
      //   }
      // } else {
      //   return state
      // }
    case "CHANGE_NUMBER":
      return { ...state, number: action.payload }
      // return {
      //   ...state,
      //   project:{
      //     ...state.project,
      //     phaseOne:{
      //       ...state.project.phaseOne,
      //       number: action.payload
      //     }
      //   }
      // }
    case "CHANGE_RDUID":
      return { ...state, rduid: action.payload }
/////////////////////////// ENDING OF PHASE ONE
/////////////////////////// BEGINING OF PHASE TWO
    case "CHANGE_PROJECT_LEADS":
      return { ...state, projectLeads: action.payload }
      // return {
      //   ...state,
      //   project:{
      //     ...state.project,
      //     phaseTwo:{
      //       ...state.project.phaseTwo,
      //       projectLeads: action.payload
      //     }
      //   }
      // }
    case "CHANGE_ANALYSTS":
      return { ...state, analysts: action.payload }
      // return {
      //   ...state,
      //   project:{
      //     ...state.project,
      //     phaseTwo:{
      //       ...state.project.phaseTwo,
      //       analysts: action.payload
      //     }
      //   }
      // }
/////////////////////////// ENDING OF PHASE TWO

/////////////////////////// BEGINING OF PHASE THREE
case "CHANGE_DIRECTORY":
  return { ...state, directory: action.payload }
  // return {
  //   ...state,
  //   project:{
  //     ...state.project,
  //     phaseThree:{
  //       ...state.project.phaseThree,
  //       directory: action.payload
  //     }
  //   }
  // }
    // case "CHANGE_METADATA_VALUES":
    //   const metadataValues = [...state.project.phaseThree.metadataValues]
    //   const filteredMetaDataValues = metadataValues.filter(value => value.metadata !== action.payload.metadata)
    //   return {
    //     ...state,
    //     project:{
    //       ...state.project,
    //       phaseThree:{
    //         ...state.project.phaseThree,
    //         metadataValues: [...filteredMetaDataValues, ...action.payload.values]
    //       }
    //     }
    //   }
/////////////////////////// ENDING OF PHASE THREE

/////////////////////////// BEGINING OF PHASE FOUR
    // case "CHANGE_UPDATES":
    //   return {
    //     ...state,
    //     project:{
    //       ...state.project,
    //       phaseFour:{
    //         ...state.project.phaseFour,
    //         update: action.payload
    //       }
    //     }
    //   }
    // case "ADD_DELIVERABLE_TO_PHASE_FOUR":
    //   return {
    //     ...state,
    //     project:{
    //       ...state.project,
    //       phaseFour:{
    //         ...state.project.phaseFour,
    //         deliverables: [...state.project.phaseFour.deliverables, action.payload]
    //       }
    //     }
    //   }
    // case "EDIT_DELIVERABLE_PHASE_FOUR":
    //   state.project.phaseFour.deliverables[action.payload.index] = action.payload
    //   return {
    //     ...state,
    //     project:{
    //       ...state.project,
    //       phaseFour:{
    //         ...state.project.phaseFour,
    //         deliverables: [...state.project.phaseFour.deliverables]
    //       }
    //     }
    //   }
    // case "REMOVE_DELIVERABLE":
    //   let filteredDeliverables = state.project.phaseFour.deliverables.filter(deliverable => deliverable.name !== action.payload)
    //   return {
    //     ...state,
    //     project:{
    //       ...state.project,
    //       phaseFour:{
    //         ...state.project.phaseFour,
    //         deliverables: filteredDeliverables
    //       }
    //     }
    //   }
/////////////////////////// ENDING OF PHASE FOUR
    default:
      return state
  }
}

export const changePhase = (phase) => {
  return {type:"CHANGE_PHASE", payload: phase}
}

export const resetPhase = () => {
  return {type:"RESET_PHASE", payload: 1}
}

export const changeStartDate = (startDate) => {
  return {type:"CHANGE_START_DATE", payload: startDate}
}

export const changeTargetEndDate = (targetEndDate) => {
  return {type:"CHANGE_TARGET_END_DATE", payload: targetEndDate}
}

export const changeStatus = (status) => {
  return {type:"CHANGE_STATUS", payload: status}
}

export const changeRegulatoryRelated = (regulatoryRelated) => {
  return {type:"CHANGE_REGULATORY_RELATED", payload: regulatoryRelated}
}

export const changeBudgetedHours = (hours) => {
  return {type:"CHANGE_BUDGETED_HOURS", payload: hours}
}

export const changeNumber = (number) => {
  if (number.length && number.length > 4) {
    return
  }

  const parsedNumber = Number(number)

  if (parsedNumber < 0 || number === '' || parsedNumber % 1 !== 0) {
    number = ''
  }

  return { type:"CHANGE_NUMBER", payload: number }
}

export const changeTitle = (title) => {
  return {type:"CHANGE_TITLE", payload: title}
}

export const changeShortId = (shortId) => {
  return {type:"CHANGE_SHORT_ID", payload: shortId}
}

export const changeClient = (clientURL) => {
  return {type:"CHANGE_CLIENT", payload: clientURL}
}

export const changeProposals = (proposals) => {
  return {type:"CHANGE_PROPOSALS", payload: proposals}
}

export const changeDescription = (description) => {
  return {type:"CHANGE_DESCRIPTION", payload: description}
}

export const changeRDUID = (rduid) => {
  return {type:"CHANGE_RDUID", payload: rduid}
}
/// PHASE ONE ACTIONS END

/// PHASE TWO ACTIONS BEGIN
export const changeProjectLeads = (data) => {
  return {type:"CHANGE_PROJECT_LEADS", payload: data}
}

export const changeAnalysts = (data) => {
  return {type:"CHANGE_ANALYSTS", payload: data}
}
/// PHASE TWO ACTIONS END

/// PHASE THREE ACTIONS BEGIN
export const changeDirectory = (data) => {
  return {type:"CHANGE_DIRECTORY", payload: data}
}

// export const changeMetadataValues = (values, metadata) => {
//   return {type:"CHANGE_METADATA_VALUES", payload: { values, metadata }}
// }
/// PHASE THREE ACTIONS END

/// PHASE FOUR ACTIONS BEGIN
// export const changeUpdate = (update) => {
//   return {type:"CHANGE_UPDATES", payload: update}
// }
//
// export const addDeliverable = (deliverable) => {
//   return {type:"ADD_DELIVERABLE_TO_PHASE_FOUR", payload: deliverable}
// }
//
// export const editDeliverable = (data) => {
//   return {type:"EDIT_DELIVERABLE_PHASE_FOUR", payload: data}
// }
//
// export const removeDeliverable = (data) => {
//   return {type:"REMOVE_DELIVERABLE", payload: data}
// }
/// PHASE FOUR ACTIONS END




export const submitProject = (props) => {
  swal({
    text: "Creating a project...",
    icon: require("../../../static/images/spinner.gif"),
    button: false
  })

  let start_date
  let target_end_date

  const {
    shortId,
    number,
    client,
    title,
    description,
    status,
    regulatoryRelated,
    budgetedHours,
    startDate,
    targetEndDate,
    projectLeads,
    analysts,
    // proposals,
    directory,
    rduid
  } = props

  if (startDate) {
    start_date = new Date(startDate).toJSON().split("T")[0]
  } else {
    start_date = new Date().toJSON().split("T")[0]
  }

  if (targetEndDate) {
    target_end_date = new Date(targetEndDate).toJSON().split("T")[0]
  } else {
    target_end_date = null
  }

  return (dispatch) => {
    const newProject = {
      created_by: {},
      // proposals: proposals.map(proposal => proposal.url),
      short_id: shortId,
      project_leads: projectLeads.map(lead => lead.url),
      analysts: analysts.map(analyst => analyst.url),
      client,
      title,
      number,
      description,
      status,
      regulatory_related: regulatoryRelated,
      budgeted_hours: budgetedHours,
      start_date,
      target_end_date,
      directory,
      rduid
    }

    axios({
      method:"POST",
      url: `${getServerURL()}projects/`,
      headers: { "Authorization": "Bearer " + localStorage.getItem("token") },
      data: newProject,
    })
    .then(response => {
      swal({
        title: "Success",
        text: `Project ${title} has been created`,
        icon: "success",
        button: "Continue",
      })
      .then(() => {
        props.history.push(`/projects/${response.data.id}/project-overview`)
        dispatch(resetPhase())
      })
    })
    .catch(error => {
      const message = "There was an error creating your project"
      handleErrorFetchingData(error, message)
    })
  }
}







// export const submitProject = (projectForCreation, currentUser, history) => {
//   swal({
//     text: "Creating a project...",
//     icon: require("../../../static/images/spinner.gif"),
//     button: false
//   })
//
//   let start_date
//   let completion_date
//
//   const { phaseOne, phaseTwo, phaseThree, phaseFour } = projectForCreation
//
//   if (phaseOne.startDate) {
//     start_date = new Date(phaseOne.startDate).toJSON().split("T")[0]
//   } else {
//     start_date = new Date().toJSON().split("T")[0]
//   }
//
//   if (phaseOne.targetEndDate) {
//     completion_date = new Date(phaseOne.targetEndDate).toJSON().split("T")[0]
//   } else {
//     completion_date = null
//   }
//
//   let update = null
//
//   if (phaseFour.update.length > 0) {
//     update = {
//       name: parseTitleFromHtml(phaseFour.update),
//       body: phaseFour.update,
//     }
//   }
//
//   return (dispatch) => {
//     let structuredProject = {
//       created_by: {},
//       short_id: phaseOne.shortId,
//       client: phaseOne.client,
//       proposals: phaseOne.proposals.map(proposal => proposal.url),
//       title: phaseOne.title,
//       number: phaseOne.number,
//       description: phaseOne.description,
//       status: phaseOne.status,
//       start_date: start_date,
//       completion_date: completion_date,
//
//       project_leads: phaseTwo.projectLeads.map(lead => lead.url),
//       analysts: phaseTwo.analysts.map(analyst => analyst.url),
//
//       directory: phaseThree.directory,
//       metadata_values: phaseThree.metadataValues.map(value => value.url),
//
//       deliverables: phaseFour.deliverables,
//       update,
//     }
//     axios({
//       method:"POST",
//       url:`${getServerURL()}projects/`,
//       headers:{"Authorization": "Bearer " + localStorage.getItem("token")},
//       data:{
//         ...structuredProject
//       }
//     })
//     .then(response => {
//       swal({
//         title: "Success!",
//         text: `Project ${phaseOne.title} has been created!`,
//         icon: "success",
//         button: "Continue!",
//       })
//       .then(() => {
//         history.push(`/projects/${response.data.id}/project-overview`)
//         dispatch(resetPhase())
//       })
//     })
//     .catch(error => {
//       const message = "There was an error creating your project"
//       handleErrorFetchingData(error, message)
//     })
//   }
// }





export const submitUpdates = (data, project, currentUser) => {
  return function(dispatch){
    axios({
      method:"POST",
      url:`${getServerURL()}updates/`,
      headers:{"Authorization": "Bearer " + localStorage.getItem("token")},
      data:{
        created_by: currentUser.url,
        name: data.phaseFour.updates.slice(0, 255),
        body: data.phaseFour.updates,
        projects: project.url
      }
    })
    .then(response => {
      if(data.phaseFour.deliverables.length > 0){
        for (let i = 0; i < data.phaseFour.deliverables.length; i++) {
          if (i + 1 === data.phaseFour.deliverables.length) {
            dispatch(submitDeliverable(data.phaseFour.deliverables[i], data, project, currentUser,"LAST"))
          } else {
            dispatch(submitDeliverable(data.phaseFour.deliverables[i], data, project, currentUser, false))
          }
        }
      } else {
        dispatch(getProjects())
        swal({
          title: "Success!",
          text: "The project has been created!",
          icon: "success",
          button: "Continue!",
        });
      }
    })
    .catch(error => {
      const message = "There was an error in creating your project *status*"
      handleErrorFetchingData(error, message)
    })
  }
}

export const submitDeliverable = (deliverable, data, project, currentUser, isLast) => {
  return function(dispatch){
    axios({
      method:"POST",
      url:`${getServerURL()}project-deliverables/`,
      headers:{"Authorization": "Bearer " + localStorage.getItem("token")},
      data:{
        created_by: currentUser.url,
        name: deliverable.name,
        description: deliverable.description,
        status: deliverable.status,
        projects: project.url,
        due_date: new Date(deliverable.dueDate).toJSON().split("T")[0]
      }
    })
    .then(response => {
      if (isLast) {
        dispatch(getProjects())
        swal({
          title: "Success!",
          text: "The project has been created!",
          icon: "success",
          button: "Continue!",
        })
      }
    })
    .catch(error => {
      const message = "There was an error in creating your project *deliverable*"
      handleErrorFetchingData(error, message)
    })
  }
}

export const constructSharedDriveSuccess = jobInputs => {
  return {type: 'SUBMIT_SUCCESS'}
}

export const constructSharedDriveFailed = () => {
  return {type: 'SUBMIT_FAILED'}
}

export const constructSharedDrive = (submitArray) => {
  return function(dispatch){
    axios.post('https://magneto.gens1.com/ptor/constructSharedDrive.php',
				qs.stringify({'submit': 'true','jobInputs':submitArray}))
		.then(response => dispatch(constructSharedDriveSuccess()))
		.catch(error => dispatch(constructSharedDriveFailed()))
  }
}



// WEBPACK FOOTER //
// ./src/routes/projects/reducers/manageProjectCreation.js